import React from "react";
import PropTypes from "prop-types";
import { toogleShareBox } from "../../Utils/DOM-Manipulation";

const Copy = (props) => {
  const { darkMode, colors, size, className, setOpen, isMobile, action, link } =
    props;

  return (
    <svg
      className={className}
      width={size.width}
      height={size.height}
      onClick={() => {
        action(link);
        isMobile ? setOpen(false) : toogleShareBox(isMobile);
      }}
      viewBox="0 0 482 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="copy">
        <g id="Group">
          <path
            id="Vector"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M373.126 58.1667V90.375H423.879H423.92V90.4583C439.949 90.5 454.48 97 464.972 107.542C475.38 118 481.875 132.458 481.917 148.458H482V148.542V453.833V453.875H481.917C481.875 469.875 475.38 484.417 464.847 494.958C454.397 505.375 439.949 511.875 423.962 511.917V512H423.879H166.995H166.953V511.917C150.966 511.875 136.394 505.375 125.902 494.833C115.493 484.375 108.999 469.917 108.957 453.917H108.874V453.833V385.458H58.1215H58.0798V385.375C42.0923 385.333 27.5203 378.833 17.0284 368.292C6.61985 357.833 0.124903 343.375 0.0832686 327.375H0V327.292V58.1667V58.125H0.0832686C0.124903 42.0833 6.66148 27.5417 17.1533 17.0417C27.6035 6.625 42.0506 0.125 58.0382 0.0833333V0H58.1215H315.005H315.047V0.0833333C331.076 0.125 345.606 6.625 356.098 17.1667C366.507 27.625 373.001 42.0833 373.043 58.0833H373.126V58.1667V58.1667ZM329.077 90.375V58.1667V58.0833H329.161C329.161 54.2917 327.537 50.7917 324.956 48.2083C322.416 45.6667 318.877 44.0417 315.088 44.0417V44.125H315.047H58.1631H58.0798V44.0417C54.2911 44.0417 50.7938 45.6667 48.2125 48.25C45.6728 50.7917 44.0491 54.3333 44.0491 58.125H44.1323V58.1667V327.292V327.375H44.0491C44.0491 331.167 45.6728 334.667 48.2541 337.25C50.7938 339.792 54.3327 341.417 58.1215 341.417V341.333H58.1631H108.915V148.542V148.5H108.999C109.04 132.458 115.577 117.917 126.069 107.417C136.519 97 150.966 90.5 166.953 90.4583V90.375H167.037H329.077ZM437.909 453.833V148.542V148.458H437.993C437.993 144.667 436.369 141.167 433.788 138.583C431.248 136.042 427.709 134.417 423.92 134.417V134.5H423.879H166.995H166.912V134.417C163.123 134.417 159.626 136.042 157.045 138.625C154.505 141.167 152.881 144.708 152.881 148.5H152.964V148.542V453.833V453.917H152.881C152.881 457.708 154.505 461.208 157.086 463.792C159.626 466.333 163.165 467.958 166.953 467.958V467.875H166.995H423.879H423.962V467.958C427.751 467.958 431.248 466.333 433.829 463.75C436.369 461.208 437.993 457.667 437.993 453.875H437.909V453.833V453.833Z"
            fill={!darkMode ? colors.dark : colors.light}
          />
        </g>
      </g>
    </svg>
  );
};

Copy.propTypes = {
  darkMode: PropTypes.bool,
  colors: PropTypes.objectOf(PropTypes.string),
  size: PropTypes.objectOf(PropTypes.string),
  className: PropTypes.string,
  setOpen: PropTypes.func,
  isMobile: PropTypes.bool,
  action: PropTypes.func,
  link: PropTypes.string,
};

export default Copy;
